import { AiOutlineEdit } from 'react-icons/ai';

interface IProps {
  storeId: string;
  toggleModal: () => any;
}

const DEFAULT_NOT_EXIST_MSG = 'No default api config exists for this store.';
const ADD_DEFAULT_BUTTON_LABEL = 'Add Default API Config';

const NoDataContainer: React.FC<IProps> = ({ toggleModal }) => {
  return (
    <div onClick={toggleModal} className="h-full w-full justify-center items-center flex flex-col">
      <span className="text-lg">{DEFAULT_NOT_EXIST_MSG}</span>
      <div className="flex py-2 text-gray-50 px-2 bg-[#1D8A43] text-center rounded-lg space-between  justify-center items-center">
        <AiOutlineEdit size={20} />
        <button className="text-sm px-2">{ADD_DEFAULT_BUTTON_LABEL}</button>
      </div>
    </div>
  );
};

export default NoDataContainer;
